import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogSuggestionsFromDatabaseComponent } from './dialog-suggestions-from-database.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    DialogSuggestionsFromDatabaseComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    DialogSuggestionsFromDatabaseComponent
  ]
})
export class DialogSuggestionsFromDatabaseModule { } 